import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import walletIcon from '../../../theme/assets/svg/tc_cab_settings_wallet_icon.svg';
import networkIcon from '../../../theme/assets/svg/tc_cab_settings_network_icon.svg';
import statusIcon from '../../../theme/assets/svg/tc_cab_settings_status_icon.svg';
import {useDispatch, useSelector} from "react-redux";
import {walletShorter} from "../../../helpers/walletShorter";
import {setSettingsChangeWalletModalStatus} from "../../../store/cabinet/action";
import CabinetHello from "../../_UI/cabinetHello";


const CabinetSettingsMain = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.posWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.noteWrap}`}>
                    <CabinetHello
                        title={t('Добро пожаловать в Настройки!')}
                        description={t('Здесь вы можете настроить безопасность вашего аккаунта, а так же подключить кошелек.')}
                    />
                </div>
                <div className={`${Styles.contentWrap} ${Styles.perspective3d}`}>
                    <div className={`${Styles.contentBox} ${Styles.border3dOuter} ${Styles.rotate3dLeft}`}>
                        <div className={`${Styles.contentBoxTitle}`}>{t('Кошелек')}</div>
                        <div className={`${Styles.walletWrap}`}>
                            <div className={`${Styles.walletRow}`}>
                                <div className={`${Styles.walletRowInfo}`}>
                                    <div className={`${Styles.walletRowIconWrap}`}>
                                        <img src={walletIcon} alt={t('Подключенный кошелек')}/>
                                    </div>
                                    <div className={`${Styles.walletRowPos}`}>
                                        <div className={`${Styles.walletRowPosName}`}>{t('Подключенный кошелек')}</div>
                                        <div className={`${Styles.walletRowPosValue}`}>{userData?.user?.wallet_address ? walletShorter(userData?.user?.wallet_address) : '...'}</div>
                                    </div>
                                </div>
                                <div className={`${Styles.walletRowBtn}`} onClick={()=>{dispatch(setSettingsChangeWalletModalStatus(true))}}>{userData?.user?.wallet_address ? t('Изменить') : t('Подключить')}</div>
                            </div>
                            <div className={`${Styles.walletRow}`}>
                                <div className={`${Styles.walletRowInfo}`}>
                                    <div className={`${Styles.walletRowIconWrap}`}>
                                        <img src={networkIcon} alt={t('Сеть')}/>
                                    </div>
                                    <div className={`${Styles.walletRowPos}`}>
                                        <div className={`${Styles.walletRowPosName}`}>{t('Сеть')}</div>
                                        <div className={`${Styles.walletRowPosValue}`}>{userData?.user?.wallet_address ? 'BNB Smart Chain (BEP-20)' : '...'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className={`${Styles.walletRow}`}>
                                <div className={`${Styles.walletRowInfo}`}>
                                    <div className={`${Styles.walletRowIconWrap}`}>
                                        <img src={statusIcon} alt={t('Статус кошелька')}/>
                                    </div>
                                    <div className={`${Styles.walletRowPos}`}>
                                        <div className={`${Styles.walletRowPosName}`}>{t('Статус кошелька')}</div>
                                        <div className={`${Styles.walletRowPosValue} ${userData?.user?.wallet_address ? Styles.walletA : Styles.walletP}`}><span>•</span> {userData?.user?.wallet_address ? t('Подключен') : t('Не подключен')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetSettingsMain;